// Cosmetic crowns awarded to whichever player currently holds the
// most wins for a given avatar (Hall of Fame top player). The
// `label` is the player-facing name of the crown. Pattern is
// "Crown of {bespoke noun}." And `title` is a third-person epithet
// derived from the avatar's `typeText` flavour string. Both render
// under the player's username wherever their name appears.
//
// Keyed by avatar display name because the table is hand-curated;
// every surface that resolves a crown already has the avatar's
// display name available from the sorcery card catalog.
//
// Adding a new avatar without an entry here causes the renderer to
// fall back to "Crown of {avatarName}" + no title, so the feature
// still works for unknown avatars but loses the curated flavour.

const CROWNS_BY_AVATAR_NAME = {
  'Avatar of Air': { label: 'Crown of the Skies', title: 'Of Thousand Winds' },
  'Avatar of Earth': { label: 'Crown of Stone', title: 'Of Enduring Strength' },
  'Avatar of Fire': { label: 'Crown of Flame', title: 'Of Desire and Destruction' },
  'Avatar of Water': { label: 'Crown of Tides', title: 'Of Ebb and Flow' },
  'Battlemage': { label: 'Crown of War', title: 'Weaver of Dread' },
  'Deathspeaker': { label: 'Crown of Last Rites', title: 'Who Turns Death to Dominion' },
  'Elementalist': { label: 'Crown of the Elements', title: 'Of Quartered Storms' },
  'Enchantress': { label: 'Crown of Enchantment', title: 'Of Honeyed Words' },
  'Pathfinder': { label: 'Crown of the Hunt', title: 'Of Untrod Ways' },
  'Seer': { label: 'Crown of Visions', title: 'Who Sees the End' },
  'Sorcerer': { label: 'Crown of Sorcery', title: 'Who Bends the Weave' },
  'Sparkmage': { label: 'Crown of Sparks', title: 'Of Thundering Heavens' },
  'Geomancer': { label: 'Crown of Geomancy', title: 'Sower of Conquest' },
  'Flamecaller': { label: 'Crown of the Inferno', title: 'Risen from the Ashes' },
  'Waveshaper': { label: 'Crown of the Tide', title: 'Turner of the Tide' },
  'Spellslinger': { label: 'Crown of Cunning', title: 'Whose Spell Speaks First' },
  'Archimago': { label: 'Crown of the Arcane', title: 'Whose Magic Strikes True' },
  'Druid': { label: 'Crown of the Grove', title: 'Watcher of the Domain' },
  'Templar': { label: 'Crown of Oaths', title: 'Sworn to Prevail' },
  'Witch': { label: 'Crown of Curses', title: 'Of Unbroken Curses' },
  'Dragonlord': { label: 'Crown of Dragons', title: 'Of Fire and Blood' },
  'Animist': { label: 'Crown of Spirits', title: 'Whom Spirits Heed' },
  'Bladedancer': { label: 'Crown of Blades', title: 'Of Bloodless Footfall' },
  'Corruptor': { label: 'Crown of Corruption', title: 'Warper of the World' },
  'Duplicator': { label: 'Crown of Mirrors', title: 'Of Twinned Selves' },
  'Harbinger': { label: 'Crown of Omens', title: 'Thrice-Crowned' },
  'Imposter': { label: 'Crown of Masks', title: 'Of Many Faces' },
  'Interrogator': { label: 'Crown of Inquisition', title: 'Whom None May Resist' },
  'Ironclad': { label: 'Crown of Iron', title: 'Whom No Blade Touches' },
  'Magician': { label: 'Crown of Magic', title: 'Whose Words Sunder' },
  'Necromancer': { label: 'Crown of the Dead', title: 'Whom the Dead Follow' },
  'Persecutor': { label: 'Crown of Pursuit', title: 'Whom None Outrun' },
  'Realm-Eater': { label: 'Crown of Ruin', title: 'Devourer of Realms' },
  'Savior': { label: 'Crown of Salvation', title: 'Bearer of Last Burdens' },
};

export function getCrownLabel(avatarName) {
  if (!avatarName) return null;
  return CROWNS_BY_AVATAR_NAME[avatarName]?.label || `Crown of ${avatarName}`;
}

export function getCrownTitle(avatarName) {
  if (!avatarName) return null;
  return CROWNS_BY_AVATAR_NAME[avatarName]?.title || null;
}
